<template>

  <ui_toastAlert :oth_showAlarmList="showAlarmList"/>

  <toast_attendanceToast/>
  <dialog_todoEdit v-if="todoEditVisible" :oth_showTodoEdit="showTodoEdit"/>
  <dialog_businessContact v-if="businessContactVisible" :oth_showBusinessContact="showBusinessContact" />
  <dialog_companyPicker @submit="handleCompanySubmit" v-if="CompanyPickerVisible" :onlyChose="true" />
  <dialog_oth_cowClicker v-if="cowClickerVisible" :oth_showCowClicker="showCowClicker" />
  <dialog_alarmList v-if="alarmListVisible" :oth_showAlarmList="showAlarmList" />
  <dialog_customerManageList v-if="customerManageListVisible" :oth_showCustomerManageList="showCustomerManageList" />
  <dialog_insuConsule v-if="insuConsuleVisible" :oth_showInsuConsule="showInsuConsule" />
  <dialog_mainCalendar v-if="mainCalendarVisible" :oth_showMainCalendar="showMainCalendar" />
  <dialog_groupInvDialog v-if="gotInvFrom" :fromGroup="gotInvFrom" @close="gotInvFrom = null" />
  <dialog_profileDialog v-if="profileDialogVisible" :oth_showProfileDialog="showProfileDialog"/>
  <dialog_boardMain v-if="boardMainVisible" :oth_showBoardMain="showBoardMain"/>
  <dialog_leaderHall v-if="leaderHallVisible" :oth_showLeaderHall="showLeaderHall"/>
  <dialog_leaderHallEdit v-if="leaderHallEditVisible" :oth_showLeaderHallEdit="showLeaderHallEdit"/>
  <dialog_CustomerEdit v-if="customerEditVisible" :editDialogSwitch="showCustomerEdit" :customer="editingCustomer" :reloadForSync="reloadForSync" />
  <dialog_caLibrary v-if="caLibraryVisible" :oth_showCALibrary="showCALibrary" />
  <dialog_caEdit v-if="caEditVisible" :p_solution="editingSolution" :closeFunction="closeCaEdit" :reload="() => {}" />
  <dialog_caPlanView v-if="planViewVisible" :planIdx="viewingPlanIdx" :closeFunction="closePlanView" />
  <dialog_customerRegister v-if="CsutomerRegisterVisible" :registerDialogSwitch="registerDialogSwitch" :reloadForSync="reloadForSync" @openEdit="handleOpenEdit"/>
  <dialog_policyList v-if="policyListVisible" :oth_showPolicyList="showPolicyList" />
  <dialog_goalList v-if="goalListVisible" :oth_showGoalListVisible="showGoalListVisible" />
  <dialog_diseaseSearch v-if="diseaseSearchVisible" @close="showDiseaseSearch(false)" @select="onDiseaseSelect" />
  <dialog_QnaList v-if="QnaListVisible" :oth_showQnA="showQnaListVisible" />
  <dialog_snsList v-if="snsVisible" :oth_showSnsList = "showSnsList"/>
  <dialog_claimExList v-if="claimExListVisible" :oth_showClaimExList = "showClaimExList" />
  <dialog_claimList v-if="claimListVisible" :oth_showClaimList = "showClaimList" />
  <dialog_crmList v-if="crmListVisible" :oth_showCrmList = "showCrmList" />
  <dialog_insuAccount v-if="insuAccountVisible" :oth_showInsuAccount = "showInsuAccount" />
  <dialog_customerMap v-if="customerMapVisible" :oth_showCustomerMap = "showCustomerMap"/>
  <dialog_curriculumList v-if="curriculumVisible" :windowOnOff="showCurriculum" />
  <dialog_myFilesDialog v-if="myFilesVisible" :oth_showMyFiles="showMyFiles" />
  <dialog_scheduleMaker v-if="scheduleMakerVisible" :oth_showScheduleMaker="showScheduleMaker" />
  <dialog_bugReport v-if="bugReportVisible" :oth_showBugReport="showBugReport" />
  <dialog_guideDialog v-if="guideVisible" :oth_showGuide="showGuide" />
  <dialog_myAssets v-if="myAssetsVisible" :oth_showMyAssets="showMyAssets" />
  <daalog_insuPortal v-if="insuPortalVisible" :oth_showinsuPortal="showinsuPortal" />
  <toast_kakaoChannel />
  <dialog_planShop v-if="planShopVisible" :oth_showPlanShop="showPlanShop" :oth_openPlanView="openPlanView" />
  <dialog_groupGoal v-if="groupGoalVisible" :oth_close="showGroupGoal" />
  <ChatWidget />
  <dialog_tutorial 
    v-if="tutorialVisible" 
    :oth_showTutorial="showTutorial" 
    type="welcome" 
    :markComplete="true" 
  />

  <div class="popup-container" v-show="popup_using !== '' && popup_using !== 'shortMenu'">
    <transition name="popup-fade">
      <!-- popup 부분 - props 전달 -->
      <popup_ProfileMenu 
        class="popup" 
        v-if="popup_using === 'ProfileMenu'" 
        :oth_showProfileDialog="showProfileDialog"
        :oth_showCowClicker="showCowClicker"
        :oth_showAlarmList="showAlarmList"
        :oth_showBugReport="showBugReport"
        :oth_showMyAssets="showMyAssets"
      />
    </transition>

    <transition name="popup-fade">
      <popup_MainMenu 
        v-if="popup_using === 'MainMenu'"
        @close="popup_using = ''" 
      />
    </transition>

    <span @click="showPopup('')" id="closer"></span>
  </div>

  
  <div class="root-container">
    <img v-if="setBG" class="background-image" :src="setBG"/>
    <div class="main-container" :class="setBG ? 'hasIMG' : ''">
      
      <ul class="header">
        <li class="left">
          <div class="logo-box" @click="showPopup('MainMenu')">
            <img class="logo" src="/imgs/LOGO.png"/>
            <div class="logo-text">BODA</div>
          </div>
        </li>
        <li class="center">
          <p>{{ system_notice_message }}</p>  
        </li>
        <li class="right">
          <div class="menu-list">
            <!--<a onclick="alert('채팅은 구현중입니다.');"> <i class="ph ph-chat-circle-dots"></i> </a>-->
            <!-- <a @click="showCowClicker(true)"> <i class="ph ph-game-controller"></i> </a>
            <a @click="showAlarmList(true)"> <i class="ph ph-bell"></i> </a>
            <a href="/setting"> <i class="ph ph-gear"></i> </a> -->
            <div class="team-avatar-area" v-if="teamMembers.length">
              <div class="team-avatar-stack" @click="toggleTeamPopup">
                <span
                  v-for="(tm, i) in teamMembers"
                  :key="tm.mb_id"
                  class="team-avatar-item"
                  :style="{ zIndex: teamMembers.length - i, animationDelay: (i * 0.06) + 's' }"
                  :title="tm.name || tm.nickname || tm.mb_id"
                >
                  <img :src="tm.image || '/imgs/unknow_user.png'" :alt="tm.name || tm.mb_id" />
                </span>
                <span v-if="teamTotalCount > 4" class="team-avatar-more" :style="{ zIndex: 0 }">
                  +{{ teamTotalCount - 4 }}
                </span>
              </div>
              <transition name="team-popup">
                <div v-if="teamPopupOpen" class="team-popup">
                  <div class="team-popup-header">
                    <span>팀원 ({{ teamTotalCount }})</span>
                    <button @click="teamPopupOpen = false"><i class="ph ph-x"></i></button>
                  </div>
                  <div class="team-popup-actions">
                    <button @click="showGroupGoal(true); teamPopupOpen = false;">
                      <i class="ph ph-target"></i> 팀 목표
                    </button>
                  </div>
                  <ul class="team-popup-list">
                    <li v-for="tm in allTeamMembers" :key="tm.mb_id">
                      <img :src="tm.image || '/imgs/unknow_user.png'" :alt="tm.name || tm.mb_id" />
                      <div class="team-popup-info">
                        <span class="team-popup-name">{{ tm.name || tm.nickname || tm.mb_id }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
            <a @click="showPopup('ProfileMenu')"> <img alt="" :src="member_info.image"> </a>
          </div>
        </li>
      </ul>


      <div class="content">
        
        <!-- 새로운 사이드 네비게이션 -->
        <nav class="side-nav" @mouseleave="handleNavLeave">
          <ul class="nav-icons">
            <li
              v-for="(item, index) in mainMenus"
              :key="index"
              :class="{ 'active': selectedMenu?.id === item.id }"
              @mouseenter="handleIconHover(item, $event)"
              ref="navIconRefs"
            >
              <div class="icon-wrapper">
                <img :src="item.icon_svg" alt="icon" />
              </div>
            </li>
          </ul>

          <!-- 서브메뉴 패널 -->
          <transition name="submenu-expand">
            <div 
              v-if="selectedMenu" 
              class="submenu-panel"
              :style="{ '--submenu-top': submenuTop + 'px' }"
              @mouseenter="cancelMenuCloseTimer"
            >
              <div class="submenu-header">
                <img :src="selectedMenu.icon_svg" alt="icon" />
                <div class="submenu-header-text">
                  <span class="submenu-title">{{ selectedMenu.title }}</span>
                  <span class="submenu-desc">{{ selectedMenu.text }}</span>
                </div>
              </div>

              <ul class="submenu-list">
                <li 
                  v-for="(menuItem, idx) in selectedMenu.menus" 
                  :key="idx" 
                  @click="menuRunAndClose(menuItem)"
                  @mouseenter="handleMenuItemHover(menuItem)"
                  @mouseleave="hoveredMenuItem = null"
                  :class="{ 'hovered': hoveredMenuItem?.title === menuItem.title }"
                  :style="{ '--delay': idx * 0.03 + 's' }"
                >
                  <i :class="menuItem.thumb"></i>
                  <span>{{ menuItem.title }}</span>
                </li>
              </ul>
            </div>
          </transition>

          <!-- 프리뷰 카드 (서브메뉴 옆) -->
          <transition name="preview-card">
            <div 
              v-if="hoveredMenuItem" 
              class="preview-card"
              :style="{ '--submenu-top': submenuTop + 'px' }"
            >
              <div class="preview-card-media">
                <img 
                  v-if="hoveredMenuItem.preview" 
                  :src="hoveredMenuItem.preview" 
                  :key="hoveredMenuItem.title"
                  alt="preview"
                />
                <div v-else class="preview-card-placeholder">
                  <i :class="hoveredMenuItem.thumb"></i>
                </div>
              </div>
              <div class="preview-card-info">
                <span class="preview-card-title">{{ hoveredMenuItem.title }}</span>
                <span class="preview-card-desc">{{ hoveredMenuItem.desc }}</span>
              </div>
            </div>
          </transition>
        </nav>


        <div class="right-menu">
        </div>


        <swiper
          :initialSlide="1"
          :slides-per-view="1"
          :space-between="24"
          :threshold="swiperThreshold"
          ref="mySwiper"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper-wrapper"
        >

          <!-- #### Birds #### start -->
          <swiper-slide key="fixed">
            <div class="special">
              <page_birds
                :oth_showQnA="showQnaListVisible"
                :oth_showClaimExList="showClaimExList"
                :oth_showLeaderHall="showLeaderHall"
                :oth_showPolicyList="showPolicyList"
              />
            </div>
          </swiper-slide>
          <!-- #### Birds #### end -->

          <!-- #### page 1 #### start -->
          <SwiperSlide>
            <div class="normal">
              <ul class="gapper">
                <!-- <li class="stack"> <new_stack_p1_A :oth_showTodoEdit="showTodoEdit"/> </li>
                <li class="stack"> <new_stack_p1_B :oth_showTodoEdit="showTodoEdit"/> </li> -->
                <!-- <li class="stack"> <new_stack_p1_C :oth_showTodoEdit="showTodoEdit"/> </li> -->
                <!-- <li class="stack"> <new_stack_p1_D :oth_showTodoEdit="showTodoEdit"/> </li> -->
                <li class="stack">
                  <new_stack_p1_E :makeCustomer="stepByStepMakeCustomer" :showCustomerManageList="showCustomerManageList" :showCrmList="showCrmList" :showInsuConsule="showInsuConsule"/>
                </li>
              </ul>
            </div>
          </SwiperSlide>
          <!-- #### page 1 #### end -->

          <!-- #### page 2 #### start -->
          <SwiperSlide>
            <div class="normal">
              <ul class="gapper">
                <li class="stack"> <new_stack_p2_B :showGoalListVisible="showGoalListVisible" :showScheduleMaker="showScheduleMaker"/> </li>
              </ul>
            </div>
          </SwiperSlide>
          <!-- #### page 2 #### end -->

          <!-- #### page 3 #### start -->
          <SwiperSlide>
            <div class="normal">
              <ul class="gapper">
                <li class="stack"> 
                  <new_stack_p3_A 
                    :oth_showBusinessContact="showBusinessContact" 
                    :oth_showDiseaseSearch="showDiseaseSearch" 
                    :oth_showClaimList="showClaimList"
                    :oth_showCALibrary="showCALibrary"
                    :oth_openSolutionEdit="openSolutionEdit"
                    :oth_openPlanView="openPlanView"
                    :oth_showPlanShop="showPlanShop"
                  /> 
                </li>
              </ul>
            </div>
          </SwiperSlide>
          <!-- #### page 3 #### end -->

          <!-- #### page 4 #### start -->
          <SwiperSlide>
            <div class="normal">
              <ul class="gapper">
                <li class="stack"> <new_stack_p4_A :oth_showPolicyList="showPolicyList" :oth_showMyFiles="showMyFiles" :oth_showClaimExList="showClaimExList" :oth_showCurriculum="showCurriculum"/> </li>
              </ul>
            </div>
          </SwiperSlide>
          <!-- #### page 4 #### end -->

          <!-- #### page 5 #### start -->
          <!-- <SwiperSlide>
            <div class="normal">
              <ul class="gapper">
                <li class="stack"> <new_stack_p5_A/> </li>
              </ul>
            </div>
          </SwiperSlide> -->
          <!-- #### page 5 #### end -->


        </swiper>

        <div class="indicator">
          <span class="feed" :key="'fixed'" :id="swiperIndex === 0 ? 'select' : ''" @click="slideTo(0)"><i class="ph-fill ph-twitter-logo"></i></span>
          <span v-for="(_, i) in slide_cnt" :key="i" :id="swiperIndex === (i + 1) ? 'select' : '' " @click="slideTo(i+1)"></span>
        </div>

        <!-- 하단 좌측 플로팅 버튼 그룹 (1024px 이하) -->
        <div class="mobile-fab-group">
          <button class="mobile-fab fab-menu" @click="mobileMenuOpen = !mobileMenuOpen" :class="{ 'is-open': mobileMenuOpen }">
            <i class="ph-bold" :class="mobileMenuOpen ? 'ph-x' : 'ph-squares-four'"></i>
          </button>
          <button class="mobile-fab" @click="toggleFullscreen">
            <i class="ph-bold" :class="isFullscreen ? 'ph-arrows-in' : 'ph-arrows-out'"></i>
          </button>
        </div>

        <!-- 모바일 바텀시트 메뉴 -->
        <transition name="bottomsheet">
          <div v-if="mobileMenuOpen" class="mobile-sheet-backdrop" @click.self="mobileMenuOpen = false">
            <div class="mobile-sheet">
              <div class="mobile-sheet-handle"></div>
              <div class="mobile-sheet-grid">
                <template v-for="(category, cIdx) in mainMenus" :key="cIdx">
                  <div class="mobile-sheet-category">
                    <div class="mobile-sheet-category-header">
                      <img :src="category.icon_svg" alt="icon" />
                      <span>{{ category.title }}</span>
                    </div>
                    <ul class="mobile-sheet-items">
                      <li 
                        v-for="(menuItem, mIdx) in category.menus" 
                        :key="mIdx"
                        @click="menuRunAndClose(menuItem); mobileMenuOpen = false;"
                      >
                        <i :class="menuItem.thumb"></i>
                        <span>{{ menuItem.title }}</span>
                      </li>
                    </ul>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </transition>

      </div>

    </div>
  </div>

</template>


<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import "swiper/swiper-bundle.min.css";
import { reactive, provide, ref, inject, onMounted, onBeforeUnmount } from 'vue';
import 'gridstack/dist/gridstack.min.css';
import io from 'socket.io-client'
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

// ui items import
import ui_toastAlert from '@/components/ui/toastAlert.vue';

// page module import
import page_birds from '@/components/modules/myBuzz.vue';

// dialog import
import dialog_todoEdit from '@/components/dialogs/todoEdit.vue';
import dialog_businessContact from '@/components/dialogs/businessContact.vue';
import dialog_companyPicker from '@/components/dialogs/insuCompanyPicker.vue';
import dialog_oth_cowClicker from '@/components/dialogs/oth_cowClicker.vue';
import dialog_alarmList from '@/components/dialogs/alarmList.vue';
import dialog_customerManageList from '@/components/dialogs/customerManageList.vue';
import dialog_insuConsule from '@/components/dialogs/insuConsule.vue';
import dialog_mainCalendar from '@/components/dialogs/mainCalendar.vue';
import dialog_groupInvDialog from '@/components/dialogs/groupInvDialog.vue';
import dialog_profileDialog from '@/components/dialogs/profileDialog.vue';
import dialog_boardMain from '@/components/dialogs/boardMain.vue';
import dialog_leaderHall from '@/components/dialogs/leaderHall.vue';
import dialog_leaderHallEdit from '@/components/dialogs/leaderHallEdit.vue';
import dialog_CustomerEdit from '@/components/dialogs/customerEdit.vue';
import dialog_caLibrary from '@/components/dialogs/caLibrary.vue';
import dialog_caEdit from '@/components/dialogs/caEdit.vue';
import dialog_caPlanView from '@/components/dialogs/caPlanView.vue';
import dialog_customerRegister from '@/components/dialogs/customerRegister.vue';
import dialog_policyList from '@/components/dialogs/policyList.vue'
import dialog_goalList from '@/components/dialogs/goalList.vue'
import dialog_diseaseSearch from '@/components/dialogs/diseaseSearch.vue';
import dialog_QnaList from '@/components/dialogs/QnAList.vue';
import dialog_snsList from '@/components/dialogs/snsList.vue';
import dialog_claimExList from '@/components/dialogs/claimExList.vue';
import dialog_claimList from '@/components/dialogs/claimList.vue';
import dialog_crmList from '@/components/dialogs/crmList.vue';
import dialog_insuAccount from '@/components/dialogs/insu_account.vue';
import dialog_customerMap from '@/components/dialogs/customerMap.vue';
import dialog_curriculumList from '@/components/dialogs/CurriculumList.vue';
import dialog_myFilesDialog from "@/components/dialogs/myFilesDialog.vue";
import dialog_scheduleMaker from '@/components/dialogs/ScheduleMakerDialog.vue';
import dialog_bugReport from '@/components/dialogs/bugReport.vue';
import dialog_guideDialog from '@/components/dialogs/guideDialog.vue';
import dialog_tutorial from '@/components/dialogs/tutorialDialog.vue';
import dialog_myAssets from '@/components/dialogs/myAssets.vue';
import daalog_insuPortal from '@/components/dialogs/insuPortal.vue';
import dialog_planShop from '@/components/dialogs/planShop.vue';
import dialog_groupGoal from '@/components/dialogs/groupGoalDialog.vue';
import ChatWidget from '@/components/dialogs/ChatWidget.vue';

// toast improt 
import toast_attendanceToast from '@/components/dialogs/AttendanceToast.vue';
import toast_kakaoChannel from '@/components/dialogs/KakaoChannelToast.vue';  

// popup import
import popup_ProfileMenu from "@/components/dialogs/profileMenu.vue";
import popup_MainMenu from "@/components/dialogs/mainMenu.vue";

// widget import
import stack_client_r_set_A from '@/components/widget/stack_client_r_set_A.vue';
import stack_client_r_set_B from '@/components/widget/stack_client_r_set_B.vue';
import stack_active_set_A from '@/components/widget/stack_active_set_A.vue';
import stack_active_set_B from '@/components/widget/stack_active_set_B.vue';
// import new_stack_p1_A from '@/components/widget/new_stack_p1_A.vue';
// import new_stack_p1_B from '@/components/widget/new_stack_p1_B.vue';
// import new_stack_p1_C from '@/components/widget/new_stack_p1_C.vue';
// import new_stack_p1_D from '@/components/widget/new_stack_p1_D.vue';
import new_stack_p1_E from '@/components/widget/new_stack_p1_E.vue';
// import new_stack_p2_A from '@/components/widget/new_stack_p2_A.vue';
import new_stack_p2_B from '@/components/widget/new_stack_p2_B.vue';
import new_stack_p3_A from '@/components/widget/new_stack_p3_A.vue';
import new_stack_p4_A from '@/components/widget/new_stack_p4_A.vue';
// import new_stack_p5_A from '@/components/widget/new_stack_p5_A.vue';
/*
import stack_tool_set_A from '@/components/widget/stack_tool_set_A.vue';
import stack_tool_set_B from '@/components/widget/stack_tool_set_B.vue';

import stack_reference_set_A from '@/components/widget/stack_reference_set_A.vue';
import stack_reference_set_B from '@/components/widget/stack_reference_set_B.vue';
import stack_staff_set_A from '@/components/widget/stack_staff_set_A.vue';
import stack_staff_set_B from '@/components/widget/stack_staff_set_B.vue';
*/



export default {
  name: 'MainPage',
  components: {
    Swiper,
    SwiperSlide,
    popup_ProfileMenu,
    popup_MainMenu,
    dialog_boardMain,
    page_birds,
    toast_attendanceToast,
    // new_stack_p1_A,
    // new_stack_p1_B,
    // new_stack_p1_C,
    // new_stack_p1_D,
    new_stack_p1_E,
    // new_stack_p2_A,
    new_stack_p2_B,
    new_stack_p3_A,
    new_stack_p4_A,
    // new_stack_p5_A,
    dialog_todoEdit,
    dialog_businessContact,
    dialog_companyPicker,
    dialog_oth_cowClicker,
    dialog_alarmList,
    ui_toastAlert,
    dialog_customerManageList,
    dialog_insuConsule,
    dialog_mainCalendar,
    dialog_groupInvDialog,
    dialog_profileDialog,
    dialog_leaderHall,
    dialog_CustomerEdit,
    dialog_caLibrary,
    dialog_caEdit,
    dialog_caPlanView,
    dialog_customerRegister,
    dialog_policyList,
    dialog_goalList,
    dialog_diseaseSearch,
    dialog_QnaList,
    dialog_snsList,
    dialog_claimExList,
    dialog_claimList,
    dialog_leaderHallEdit,
    dialog_crmList,
    dialog_insuAccount,
    dialog_customerMap,
    dialog_curriculumList,
    dialog_myFilesDialog,
    dialog_scheduleMaker,
    dialog_bugReport,
    dialog_guideDialog,
    dialog_tutorial,
    dialog_myAssets,
    daalog_insuPortal,
    toast_kakaoChannel,
    dialog_planShop,
    dialog_groupGoal,
    ChatWidget
  },
  setup() {
    const getMbid = inject("getMbid");
    const sql_query = inject("sql_query");
    const member_info = inject("member_info");
    const swiperIndex = ref(0);
    const swiperInstance = ref(null);
    const popup_using = ref('');
    const selectedMenu = ref('');
    const isMenuOpen = ref(false);
    const system_notice_message = ref('');
    const todoEditVisible = ref(false);
    const businessContactVisible = ref(false);
    const CompanyPickerVisible = ref(false);
    const cowClickerVisible  = ref(false);
    const alarmListVisible = ref(false);
    const customerManageListVisible = ref(false);
    const insuConsuleVisible = ref(false);
    const mainCalendarVisible = ref(false);
    const setBG = ref(null);
    const profileDialogVisible = ref(false);
    const boardMainVisible = ref(false);
    const leaderHallVisible = ref(false);
    const leaderHallEditVisible = ref(false);
    const editingCustomer = ref(null);
    const customerEditVisible = ref(false);
    const caLibraryVisible = ref(false);
    const CsutomerRegisterVisible = ref(false);
    const policyListVisible = ref(false);
    const goalListVisible = ref(false);
    const diseaseSearchVisible = ref(false);
    const curriculumVisible = ref(false);  // 추가
    const QnaListVisible = ref(false);
    const snsVisible = ref (false);
    const claimListVisible = ref(false);
    const crmListVisible = ref(false);
    const insuAccountVisible = ref(false);
    const customerMapVisible = ref(false);
    const claimExListVisible = ref(false);
    const myFilesVisible = ref(false);
    const scheduleMakerVisible = ref(false);
    const bugReportVisible = ref(false);
    const tutorialVisible = ref(false);
    const guideVisible = ref(false);
    const myAssetsVisible = ref(false);
    const insuPortalVisible = ref(false);
    const mobileMenuOpen = ref(false);
    const isFullscreen = ref(false);
    const planShopVisible = ref(false);
    const groupGoalVisible = ref(false);

    // TEXT (가장 간단)
    // sendBmsFree('01094953540', 'TEXT', { text: '테스트 메시지입니다' })

    function toggleFullscreen() {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        const el = document.documentElement;
        const rfs = el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen;
        if (rfs) rfs.call(el);
      } else {
        const efs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
        if (efs) efs.call(document);
      }
    }

    function onFullscreenChange() {
      isFullscreen.value = !!(document.fullscreenElement || document.webkitFullscreenElement);
    }

    // ========== 솔루션 편집 / 플랜 뷰 관련 ==========
    const caEditVisible = ref(false);
    const editingSolution = ref(null);
    const planViewVisible = ref(false);
    const viewingPlanIdx = ref(null);

    function openSolutionEdit(solution) {
      editingSolution.value = solution;
      caEditVisible.value = true;
    }

    function closeCaEdit(val = false) {
      caEditVisible.value = val;
      if (!val) editingSolution.value = null;
    }

    function openPlanView(planIdx) {
      viewingPlanIdx.value = planIdx;
      planViewVisible.value = true;
    }

    function closePlanView() {
      planViewVisible.value = false;
      viewingPlanIdx.value = null;
    }
    // ========== 솔루션 편집 / 플랜 뷰 관련 끝 ==========
    
    function showAlarmList (b) { alarmListVisible.value = b; }
    function showCowClicker (b) { cowClickerVisible.value = b; }
    function showCompanyPicker(b) { CompanyPickerVisible.value = b; }
    function showBusinessContact(b) { businessContactVisible.value = b; }
    function showTodoEdit(b) { todoEditVisible.value = b; }
    function showCustomerManageList(b) { customerManageListVisible.value = b; }
    function showInsuConsule(b) { insuConsuleVisible.value = b; }
    function showMainCalendar(b) { mainCalendarVisible.value = b; }
    function showProfileDialog(b) { profileDialogVisible.value = b; }
    function showBoardMain(b) { boardMainVisible.value = b; }
    function showLeaderHall(b) { leaderHallVisible.value = b; }
    function showLeaderHallEdit(b) { leaderHallEditVisible.value = b; }
    function showCustomerEdit(b) { customerEditVisible.value = b; }
    function showCALibrary(b)  { caLibraryVisible.value = b; }
    function registerDialogSwitch(b) { CsutomerRegisterVisible.value = b; }
    function showPolicyList(b) { policyListVisible.value = b; }
    function showGoalListVisible(b) { goalListVisible.value = b; }
    function showDiseaseSearch(b) { diseaseSearchVisible.value = b; }
    function showCurriculum(b) { curriculumVisible.value = b; }
    function showQnaListVisible(b) { QnaListVisible.value = b; }
    function showSnsList(b) { snsVisible.value = b;}
    function showClaimList(b) { claimListVisible.value = b; }
    function showCrmList(b) { crmListVisible.value = b; }
    function showInsuAccount(b) { insuAccountVisible.value = b;}
    function showCustomerMap(b) { customerMapVisible.value = b;}
    function showClaimExList(b) { claimExListVisible.value = b;}
    function showMyFiles(b) { myFilesVisible.value = b; }
    function showScheduleMaker(b) { scheduleMakerVisible.value = b; }
    function showBugReport(b) { bugReportVisible.value = b; }
    function showTutorial(b) { tutorialVisible.value = b; }
    function showGuide(b) { guideVisible.value = b; }
    function showMyAssets(b) { myAssetsVisible.value = b; }
    function showinsuPortal(b) { insuPortalVisible.value = b; }
    function showPlanShop(v) { planShopVisible.value = v; }
    function showGroupGoal(b) { groupGoalVisible.value = b; }
  
    let tutorial_home = localStorage.getItem('tutorial_home')


     const driverObj = driver({
      showProgress: true,
      allowClose: false,
      overlayClickNext: false,
      stagePadding: 4,
      nextBtnText: '다음',
      prevBtnText: '이전',
      doneBtnText: '완료',
      progressText: '{{current}} / {{total}}',
      onPopoverRender: (popover) => {
        // X 닫기 버튼 제거
        const closeBtn = popover.wrapper.querySelector('.driver-popover-close-btn');
        if (closeBtn) closeBtn.remove();
      },
      steps: [
        { 
          element: '.logo-box', 
          popover: { 
            title: '메인 메뉴', 
            description: '여기를 클릭하면 메뉴가 열립니다.',
            onNextClick: () => {
              // 스텝 1 완료 시 실행할 함수
              console.log('스텝 1 완료: 메인 메뉴');
              driverObj.moveNext();
            }
          } 
        },
        { 
          element: '.menu-list', 
          popover: { 
            title: '프로필', 
            description: '프로필과 설정을 확인할 수 있습니다.',
            onNextClick: () => {
              setTimeout(() => { slideTo(5, 2000); }, 1000);
              setTimeout(() => { slideTo(0, 3000); }, 3000);
              setTimeout(() => { slideTo(1); }, 6000);
              driverObj.moveNext();
            }
          } 
        },
        { 
          element: '.swiper-wrapper', 
          popover: { 
            title: '페이지', 
            description: '휴대폰 처럼 페이지를 스와이프할 수 있습니다.',
            onNextClick: () => { driverObj.moveNext();  }
          } 
        },
        {
          element: '.side-nav',
          popover: {
            title: '사이드 메뉴',
            description: '각 기능에 빠르게 접근하세요.',
            onNextClick: () => {
              // 마지막 스텝 완료 시 실행할 함수
              console.log('투어 완료!');
              driverObj.moveNext();
              localStorage.setItem('tutorial_home', true);
            }
          }
        }
      ],
    });
    onMounted(() => {
      if (!tutorial_home) {
        driverObj.drive();
      }
    });

    const swiperThreshold = ref(100);
    const updateSwiperThreshold = () => {
      swiperThreshold.value = window.innerWidth <= 1024 ? 0 : 100;
    };

    onMounted(async () => {
      await fetchSystemNotice();
      updateNotice();
      intervalId = setInterval(updateNotice, 5000);
      fetchUserSettings();
      
      // 초기 체크
      updateSwiperThreshold();
      // 리사이즈 감지
      window.addEventListener('resize', updateSwiperThreshold);
      // 풀스크린 감지
      document.addEventListener('fullscreenchange', onFullscreenChange);
      document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    });

    onBeforeUnmount(() => { 
      clearInterval(intervalId);
      window.removeEventListener('resize', updateSwiperThreshold);
      document.removeEventListener('fullscreenchange', onFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
    });

    function handleCompanySubmit(company) {
      CompanyPickerVisible.value = false;
      if (company) {
        if(company.system_url) {
          window.open(company.system_url, '_blank');
        } else {
          alert(`${company.name} 전용 전산이 없습니다.`);
        }
      }
    }

    function reloadForSync() {
      reloadForSync.value = !reloadForSync.value;
    }

    function stepByStepMakeCustomer() {
      registerDialogSwitch(true);
    }

    function makeCustomer() {
      editingCustomer.value = {
        idx: null,
        name: '새 고객',
        nickname: '새 고객',
        title: "고객님",
        m_type: 'X0',
        rrn: '19100101-1234567',
        birth: '',
        sex: '0',
        address: '',
        location: '',
        ex_address: '',
        phone: '010-',
        job: '',
        job_grade: '',
        job_name: '',
        job_dept: '',
        job_address: '',
        notes: '',
        med_history: '',
        tags: '',
        is_keyman: '0',
        is_offical: '0',
        vip_rank : '0',
        manage_rank : '0',
        extra_info: '',
        sns_talk : '',
        sns_ama : '',
        sns_etc : '',
        opt_visible: true,
        last_touch: '',
      };
      showCustomerEdit(true);
    }


    const slide_cnt = ref(4);

    const slides = ref([
      {stacks:[
        stack_client_r_set_A,
        stack_client_r_set_B
      ]},
      {stacks:[
        stack_active_set_A,
        stack_active_set_B,
      ]},
            {stacks:[
        stack_client_r_set_A,
        stack_client_r_set_B
      ]},
      {stacks:[
        stack_active_set_A,
        stack_active_set_B,
      ]},
            {stacks:[
        stack_client_r_set_A,
        stack_client_r_set_B
      ]},
    ]);

    async function fetchUserSettings() {
      const result = await sql_query(` select * from user_settings where mb_id = '${member_info.mb_id}' `);
      if (result && result.length > 0) {
        setBG.value = result[0].bg_img;
      }
    }
    
    /* #### NOTICE 표시 #### */
    const system_notice_message_list = ref([]);
    let noticeIndex = 0;
    let intervalId = null;

    const fetchSystemNotice = async () => {
      let sql = `SELECT * FROM board_reference 
                WHERE category_id = '1' 
                ORDER BY updated_at DESC 
                LIMIT 5`;
      const data = await sql_query(sql);
      system_notice_message_list.value = data;
    };

    const updateNotice = () => {
      if (system_notice_message_list.value.length === 0) return;
      
      // title 또는 content 중 원하는 필드 사용
      system_notice_message.value = system_notice_message_list.value[noticeIndex].title;
      noticeIndex = (noticeIndex + 1) % system_notice_message_list.value.length;
    };

    onMounted(async () => {
      await fetchSystemNotice();  // 데이터 먼저 로드
      updateNotice();             // 첫 메시지 표시
      intervalId = setInterval(updateNotice, 5000);
      fetchUserSettings();
    });

    onBeforeUnmount(() => { 
      clearInterval(intervalId); 
    });
    /* #### NOTICE 표시 #### */


    const mainMenus = reactive(
      [
        { 
          id: 'buzz',
          icon: `ph ph-twitter-logo`,
          icon_svg : require(`@/assets/icon/basic/buzz.svg`),
          title: "버즈 | Buzz", 
          text: "설계사들끼리 수다떠는 커뮤니티",
          menus:[
            {thumb:`ph-fill ph-graduation-cap`, title:`지식인`, desc:`궁금한 건 뭐든 물어보세요`, preview: "/preview/qna.gif", action: () => { showQnaListVisible(true); } },
            {thumb:`ph-fill ph-chat`, title:`커뮤니티`, desc:`자유롭게 소통하는 공간`, preview: "/preview/sns.PNG", action: () => { showSnsList(true); } },
            {thumb:`ph-fill ph-hand-heart`, title:`청구사례`, desc:`실제 보험금 청구 사례`, preview:  "/preview/claim.PNG", action: () => { showClaimExList(true); } },
            {thumb:`ph-fill ph-trophy`, title:`명예전당`, desc:`이달의 우수 설계사`, preview:  "/preview/hall.PNG", action: () => { showLeaderHall(true); } },
          ],
          isOpen: false,
        },
        { 
          id: 'client',
          icon: `ph ph-user`, 
          icon_svg : require(`@/assets/icon/basic/client.svg`),
          title: "고객", 
          text: "고객상담과 관리를 도와주는 항목들",
          menus:[
            {thumb:`ph-fill ph-user-list`, title:`고객관리`, desc:`고객 정보 등록 및 관리`, preview:  "/preview/customerList.PNG", action: () => { showCustomerManageList(true) } },
            {thumb:`ph-fill ph-check-square-offset`, title:`상담하기`, desc:`보험 상담 진행`, preview:  "/preview/counsel.PNG", action: () => { showInsuConsule(true) } },
            {thumb:`ph-fill ph-map-pin-area`, title:`고객지도`, desc:`고객 위치 한눈에 보기`, preview:  "/preview/customerMap.PNG", action: () => { showCustomerMap(true) } },
          ],
          isOpen: false,
        },

        { 
          id: 'working',
          icon: `ph ph-bag`, 
          icon_svg : require(`@/assets/icon/basic/work.svg`),
          title: "활동", 
          text: "영업활동에 반드시 필요한 항목들",
          menus:[
            {thumb:`ph-fill ph-calendar`, title:`일정관리`, desc:`스케줄 확인 및 관리`, preview:  "/preview/calendar.PNG", action: () => { showMainCalendar(true); } },
            {thumb:`ph-fill ph-target`, title:`목표설정`, desc:`월별 목표 설정`, preview:  "/preview/goal.PNG", action: () => { showGoalListVisible(true); } },
            {thumb:`ph-fill ph-chalkboard-simple`, title:`교육`, desc:`필수 교육 이수`, preview:  "/preview/edu.PNG", action: () => { showCurriculum(true); } },
            {thumb:`ph-fill ph-list-checks`, title:`일정생성`, desc:`자동 일정 생성`, preview:  "/preview/todoMake.PNG", action: () => { showScheduleMaker(true); } },
          ],
          isOpen: false,
        },
      
        { 
          id: 'tools',
          icon: `ph ph-wrench`, 
          icon_svg : require(`@/assets/icon/basic/tool.svg`),
          title: "도구", 
          text: "업무를 편하게 만들어주는 도구들",
          menus:[
            {thumb:`ph-fill ph-pencil`, title:`스케치`, desc:`자유롭게 그리고 설명하기`, preview:  "/preview/CA.PNG", action: () => { showCALibrary(true); } },
            {thumb:`ph-fill ph-hand-coins`, title:`보험사`, desc:`보험사 관련 툴`, preview:  "/preview/companyContact.PNG", action: () => { showinsuPortal(true); } },
            {thumb:`ph-fill ph-robot`, title:`CRM`, desc:`고객 관계 자동화`, preview:  "/preview/CRM.PNG", action: () => { showCrmList(true); } },
            {thumb:`ph-fill ph-identification-badge`, title:`계정정보`, desc:`보험사 계정 관리`, preview:  "/preview/accounts.PNG", action: () => { showInsuAccount(true); } },
          ], 
          isOpen: false,
        },
        { 
          id: 'reference',
          icon: `ph ph-books`, 
          icon_svg : require(`@/assets/icon/basic/reference.svg`),
          title: "자료", 
          text: "정보와 자료를 보관하는 도서관",
          menus:[
            {thumb:`ph-fill ph-books`, title:`게시판`, desc:`공지사항 및 게시글`, preview:  "/preview/board.PNG", action: () => { showBoardMain(true); } },
            {thumb:`ph-fill ph-coins`, title:`시책관리`, desc:`보험사별 시책 정보`, preview:  "/preview/bounty.PNG", action: () => { showPolicyList(true); } },
            {thumb:`ph-fill ph-cloud`, title:`드라이브`, desc:`내 파일 저장소`, preview:  "/preview/drive.PNG", action: () => { showMyFiles(true); } },
            {thumb:`ph-fill ph-book-open`, title:`가이드북`, desc:`사용법 안내`, action: () => { showGuide(true); } },
            {thumb:`ph-fill ph-question`, title:`튜토리얼`, desc:`첫사용`, action: () => { showTutorial(true); } },
          ],
          isOpen: false,
        },
      ]
    );

    setTimeout(() => {
      if (member_info.level >= 1) {
        mainMenus.push(
          { 
            id: 'manager',
            icon: `ph ph-baseball-cap`, 
            icon_svg : require(`@/assets/icon/basic/manager.svg`),
            title: "관리자", 
            text: "관리자만 사용 가능한 도구",
            menus:[
              {thumb:`ph ph-gear-fine`, title:`ADMIN`, desc:`관리자 페이지`, preview: "/preview/sns.PNG", action: () => { window.location.href = '/admin' } },
              {thumb:`ph ph-git-branch`, title:`그룹관리`, desc:`그룹 설정 및 관리`, preview:  "/preview/sns.PNG", action: () => { window.location.href = '/admin/group' } },
              {thumb:`ph ph-trophy`, title:`전당업뎃`, desc:`명예전당 업데이트`, preview:  "/preview/sns.PNG", action: () => { showLeaderHallEdit(true) } },
            ],
            isOpen: false,
          },
        );
      }
    }, 500);
    

    provide("mainMenus", mainMenus);

    function showPopup(popupName) {
      popup_using.value = popupName;
      if (popupName == '') {
        selectedMenu.value = '';
      }
    }

    function openMenus(item) {
      selectedMenu.value = item;
    }

    function menuRunAndClose(item) {
      hoveredMenuItem.value = null;  // 여기에 추가
      item.action();
      closeMenu();
    }

    function closeMenu() {
      selectedMenu.value = null;
      popup_using.value = '';
    }

    // 서브메뉴 위치
    const submenuTop = ref(0);
    
    // 현재 hover된 서브메뉴 아이템
    const hoveredMenuItem = ref(null);

    // 메뉴 hover 처리용 타이머
    const menuCloseTimer = ref(null);

    function startMenuCloseTimer() {
      menuCloseTimer.value = setTimeout(() => {
        closeMenu();
      }, 200);
    }

    function cancelMenuCloseTimer() {
      if (menuCloseTimer.value) {
        clearTimeout(menuCloseTimer.value);
        menuCloseTimer.value = null;
      }
    }

    function handleIconHover(item, event) {
      cancelMenuCloseTimer();
      selectedMenu.value = item;
      hoveredMenuItem.value = null; // 메뉴 바뀔 때 초기화
      
      // 아이콘 위치 계산해서 서브메뉴 위치 설정
      const iconEl = event.currentTarget;
      const navEl = iconEl.closest('.side-nav');
      if (iconEl && navEl) {
        const iconRect = iconEl.getBoundingClientRect();
        const navRect = navEl.getBoundingClientRect();
        submenuTop.value = iconRect.top - navRect.top;
      }
    }
    
    function handleMenuItemHover(menuItem) {
      hoveredMenuItem.value = menuItem;
    }

    function handleNavLeave() {
      startMenuCloseTimer();
    }

    function handleShortMenuLeave() {
      cancelMenuCloseTimer();
      closeMenu();
    }

    // ✅ Swiper 이벤트 핸들러
    const onSwiper = (swiper) => {
      swiperIndex.value = swiper.activeIndex;
      swiperInstance.value = swiper;
    };

    const onSlideChange = (swiper) => {
      swiperIndex.value = swiper.activeIndex;
    };

    async function slideTo(i, speed = 1000) {
      swiperIndex.value = i;
      swiperInstance.value?.slideTo(i, speed, false);
    }

    const gotInvFrom = ref(null);
    async function checkGroupInv() {
      const res = await sql_query(`SELECT * FROM group_member WHERE mb_id = '${getMbid()}' and status = 'invited' limit 1`);
      if (res.length) {
        gotInvFrom.value = res;
      }
    }
    checkGroupInv();

    const teamMembers = ref([]);
    const teamTotalCount = ref(0);
    const teamPopupOpen = ref(false);
    const allTeamMembers = ref([]);

    async function fetchTeamMembers() {
      const mbId = getMbid();
      if (!mbId) return;
      const countRes = await sql_query(`
        SELECT COUNT(*) as cnt
        FROM group_member
        WHERE main_group_idx = (
          SELECT main_group_idx FROM group_member WHERE mb_id = '${mbId}' AND status = 'join' LIMIT 1
        )
        AND status = 'join'
        AND mb_id != '${mbId}'
      `);
      teamTotalCount.value = countRes?.[0]?.cnt || 0;

      const rows = await sql_query(`
        SELECT gm.mb_id, m.name, m.nickname, m.image
        FROM group_member gm
        LEFT JOIN member m ON gm.mb_id = m.mb_id
        WHERE gm.main_group_idx = (
          SELECT main_group_idx FROM group_member WHERE mb_id = '${mbId}' AND status = 'join' LIMIT 1
        )
        AND gm.status = 'join'
        AND gm.mb_id != '${mbId}'
        ORDER BY gm.joined_at ASC
      `);
      if (Array.isArray(rows)) {
        allTeamMembers.value = rows;
        teamMembers.value = rows.slice(0, 4);
      }
    }
    fetchTeamMembers();

    function toggleTeamPopup() {
      teamPopupOpen.value = !teamPopupOpen.value;
    }

    // webSocket
    const WSstatus = ref('⏳ 연결 중...')
    const socket = io('https://bodiary.com', { transports: ['websocket'] })

    onMounted(() => {
      socket.on('connect', () => {
        WSstatus.value = '✅ 연결됨'
        console.log('connected:', socket.id)
      })
      socket.on('disconnect', () => {
        WSstatus.value = '❌ 끊김'
      })
    })
    // onBeforeUnmount(() => {
    //   if (socket) socket.close();
    // });

    function handleOpenEdit(customer) {
      editingCustomer.value = customer;
      customerEditVisible.value = true;
    }
    
    function onDiseaseSelect(payload) {
      console.log('선택된 질병:', payload.disease);
      // 필요한 처리 후 다이얼로그 닫기
      diseaseSearchVisible.value = false;
    }
    
    return { 
      onSwiper,
      onSlideChange,
      swiperIndex,
      member_info,
      mainMenus,
      popup_using,
      showPopup,
      openMenus,
      selectedMenu,
      slides,
      system_notice_message,
      todoEditVisible,
      showTodoEdit,
      businessContactVisible,
      showBusinessContact,
      showCompanyPicker,
      handleCompanySubmit,
      CompanyPickerVisible,
      cowClickerVisible,
      showCowClicker,
      alarmListVisible,
      showAlarmList,
      customerManageListVisible,
      insuConsuleVisible,
      showCustomerManageList,
      showInsuConsule,
      setBG,
      showMainCalendar,
      mainCalendarVisible,
      gotInvFrom,
      WSstatus,
      profileDialogVisible,
      showProfileDialog,
      boardMainVisible,
      showBoardMain,
      leaderHallVisible,
      showLeaderHall,
      customerEditVisible,
      showCustomerEdit,
      editingCustomer,
      reloadForSync,
      makeCustomer,
      closeMenu,
      menuRunAndClose,
      startMenuCloseTimer,
      cancelMenuCloseTimer,
      handleShortMenuLeave,
      submenuTop,
      handleIconHover,
      handleNavLeave,
      hoveredMenuItem,
      handleMenuItemHover,
      showCALibrary,
      caLibraryVisible,
      CsutomerRegisterVisible,
      registerDialogSwitch,
      stepByStepMakeCustomer,
      slide_cnt,
      policyListVisible,
      showPolicyList,
      goalListVisible,
      showGoalListVisible,
      handleOpenEdit,
      isMenuOpen,
      swiperThreshold,
      showDiseaseSearch,
      diseaseSearchVisible,
      onDiseaseSelect,
      curriculumVisible,
      showCurriculum,
      slideTo,
      QnaListVisible,
      showQnaListVisible,
      snsVisible,
      showSnsList,
      claimListVisible,
      showClaimList,
      showLeaderHallEdit,
      leaderHallEditVisible,
      crmListVisible,
      showCrmList,
      insuAccountVisible,
      showInsuAccount,
      customerMapVisible,
      showCustomerMap,
      claimExListVisible,
      showClaimExList,
      myFilesVisible,
      showMyFiles,
      scheduleMakerVisible, showScheduleMaker,
      bugReportVisible, showBugReport,
      tutorialVisible, showTutorial,
      guideVisible, showGuide,
      caEditVisible,
      editingSolution,
      planViewVisible,
      viewingPlanIdx,
      openSolutionEdit,
      closeCaEdit,
      openPlanView,
      closePlanView,
      showMyAssets,
      myAssetsVisible,
      showinsuPortal,
      insuPortalVisible,
      mobileMenuOpen,
      isFullscreen,
      toggleFullscreen,
      showPlanShop,
      planShopVisible,
      teamMembers,
      teamTotalCount,
      teamPopupOpen,
      allTeamMembers,
      toggleTeamPopup,
      groupGoalVisible,
      showGroupGoal
    };

  },
};
</script>


<style scoped>

.root-container {
  --one:light-dark(#c8ecff, #3a4666);
  --two:light-dark(#bc75ff, #251369);
  background: linear-gradient(45deg, var(--one), var(--two));
  background-size: 400% 400%;
  animation: gradientMove 20s ease infinite;
}

@keyframes gradientMove {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@media print {
  .root-container {
    display: none !important;
  }
}

@media (max-width: 580px) {
  .main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide {
    justify-content: center !important;
  }
  .main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .normal {
    height: auto !important;
    align-items: start !important;
    justify-content: start !important;
    aspect-ratio: 6 / 4 auto !important;
  }
  .main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .special {
    height: 100% !important;
    align-items: start !important;
    justify-content: start !important;
  }
  .team-avatar-item {
    width: 22px;
    height: 22px;
    margin-left: -8px;
  }
  .team-avatar-more {
    width: 22px;
    height: 22px;
    font-size: 9px;
    margin-left: -8px;
  }
  .team-avatar-stack {
    padding: 2px 4px;
  }
}


.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: all 0.3s ease;
}

.popup-fade-enter-from,
.popup-fade-leave-to {
  opacity: 0;
  transform: scale(0.2);
}

.popup-fade-enter-to,
.popup-fade-leave-from {
  opacity: 1;
  transform: scale(1);
}



/* #### Side Navigation #### */

.side-nav {
  position: fixed;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: var(--z-index-base);
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.nav-icons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  margin: 0;
  list-style: none;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.nav-icons > li {
  position: relative;
}

.nav-icons > li > .icon-wrapper {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  cursor: pointer;
  transition: 
    transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
    background 0.3s ease,
    box-shadow 0.3s ease;
  background: transparent;
}

.nav-icons > li > .icon-wrapper > img {
  width: 22px;
  height: 22px;
  opacity: 0.7;
  transition: 
    opacity 0.3s ease,
    transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
    filter 0.3s ease;
}

.nav-icons > li:hover > .icon-wrapper {
  background: rgba(255, 255, 255, 0.15);
  transform: scale(1.1) translateX(4px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.nav-icons > li:hover > .icon-wrapper > img {
  opacity: 1;
  transform: scale(1.15);
  filter: drop-shadow(0 2px 8px rgba(255, 255, 255, 0.2));
}

.nav-icons > li.active > .icon-wrapper {
  background: var(--color-brand, #6366f1);
  box-shadow: 0 4px 20px rgba(99, 102, 241, 0.5);
  transform: scale(1.05);
}

.nav-icons > li.active > .icon-wrapper > img {
  opacity: 1;
  filter: brightness(1.3) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

/* 서브메뉴 패널 */
.submenu-panel {
  position: absolute;
  left: 100%;
  top: var(--submenu-top, 0);
  margin-left: 16px;
  min-width: 220px;
  background: rgba(15, 15, 25, 0.9);
  backdrop-filter: blur(30px);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 
    0 25px 80px rgba(0, 0, 0, 0.35),
    0 0 0 1px rgba(255, 255, 255, 0.05) inset,
    0 0 60px rgba(99, 102, 241, 0.1);
  overflow: hidden;
  transform-origin: left center;
}

.submenu-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.submenu-header > img {
  width: 28px;
  height: 28px;
  opacity: 0.95;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.submenu-header-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.submenu-header-text > .submenu-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: -0.02em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.submenu-header-text > .submenu-desc {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: -0.01em;
}

/* 프리뷰 카드 (서브메뉴 옆) */
.preview-card {
  position: absolute;
  left: calc(100% + 240px);
  top: var(--submenu-top, 0);
  width: 280px;
  background: rgba(15, 15, 25, 0.92);
  backdrop-filter: blur(30px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 
    0 25px 80px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.05) inset,
    0 0 40px rgba(99, 102, 241, 0.1);
  overflow: hidden;
  transform-origin: left center;
}

.preview-card-media {
  width: 100%;
  aspect-ratio: 16 / 10;
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  position: relative;
}

.preview-card-media > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: previewFadeIn 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.preview-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(0, 0, 0, 0.3) 100%);
}

.preview-card-placeholder > i {
  font-size: 56px;
  color: var(--color-brand, #6366f1);
  opacity: 0.9;
  animation: iconBounce 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  filter: drop-shadow(0 4px 20px rgba(99, 102, 241, 0.4));
}

.preview-card-info {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.preview-card-title {
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  letter-spacing: -0.02em;
}

.preview-card-desc {
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
}

/* 프리뷰 카드 애니메이션 */
.preview-card-enter-active {
  transition: 
    opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.preview-card-leave-active {
  transition: 
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.preview-card-enter-from {
  opacity: 0;
  transform: translateX(-20px) scale(0.9);
}

.preview-card-leave-to {
  opacity: 0;
  transform: translateX(-10px) scale(0.95);
}

@keyframes previewFadeIn {
  from {
    opacity: 0;
    transform: scale(1.05);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes iconBounce {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  60% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.submenu-list {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 0;
  list-style: none;
}

.submenu-list > li {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 14px;
  cursor: pointer;
  transition: 
    background 0.25s ease,
    transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
    box-shadow 0.25s ease;
  animation: submenuItemIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) backwards;
  animation-delay: var(--delay, 0s);
}

.submenu-list > li:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateX(6px) scale(1.02);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.submenu-list > li.hovered {
  background: rgba(99, 102, 241, 0.2);
  border-left: 3px solid var(--color-brand, #6366f1);
  padding-left: 15px;
}

.submenu-list > li:active {
  transform: translateX(4px) scale(0.98);
  transition: transform 0.1s ease;
}

.submenu-list > li > i {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.6);
  width: 26px;
  text-align: center;
  transition: 
    color 0.25s ease,
    transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
    text-shadow 0.25s ease;
}

.submenu-list > li > span {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  transition: color 0.25s ease;
}

.submenu-list > li:hover > i {
  color: #fff;
  transform: scale(1.2);
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.4);
}

.submenu-list > li:hover > span {
  color: #fff;
}

/* 서브메뉴 애니메이션 - 더 부드럽게 */
.submenu-expand-enter-active {
  transition: 
    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.submenu-expand-leave-active {
  transition: 
    opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.submenu-expand-enter-from {
  opacity: 0;
  transform: translateX(-20px) scale(0.9);
}

.submenu-expand-leave-to {
  opacity: 0;
  transform: translateX(-10px) scale(0.95);
}

@keyframes submenuItemIn {
  from {
    opacity: 0;
    transform: translateX(-16px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

/* 인접 아이콘 반응 효과 */
.nav-icons > li:hover + li > .icon-wrapper,
.nav-icons > li:has(+ li:hover) > .icon-wrapper {
  transform: scale(1.03);
  opacity: 0.85;
}

/* 모바일 대응 */
@media (max-width: 1024px) {
  .preview-card {
    display: none;
  }
  .side-nav {
    display: none;
  }
}

@media (max-width: 768px) {
  .submenu-panel {
    min-width: 180px;
  }
}

/* #### Side Navigation End #### */


/* #### 모바일 플로팅 버튼 + 바텀시트 #### START */

.mobile-fab-group {
  display: none;
}

@media (max-width: 1024px) {
  .mobile-fab-group {
    display: flex;
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: calc(var(--z-index-base) + 5);
    flex-direction: row;
    gap: 10px;
    /* iOS safe area 대응 */
    bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  }

  .mobile-fab {
    display: flex;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: none;
    background: rgba(40, 40, 60, 0.85);
    backdrop-filter: blur(12px);
    color: #fff;
    font-size: 20px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(0,0,0,0.3);
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.2s ease;
  }

  .mobile-fab:active {
    transform: scale(0.9);
  }

  .mobile-fab.fab-menu {
    background: var(--color-brand, #6366f1);
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.5), 0 2px 8px rgba(0,0,0,0.2);
  }

  .mobile-fab.fab-menu.is-open {
    background: rgba(40, 40, 60, 0.95);
    box-shadow: 0 4px 20px rgba(0,0,0,0.4);
  }

  .mobile-fab > i {
    transition: transform 0.3s ease;
  }

  .mobile-fab.fab-menu.is-open > i {
    transform: rotate(90deg);
  }
}

/* 바텀시트 백드롭 */
.mobile-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: calc(var(--z-index-base) + 4);
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

/* 바텀시트 본체 */
.mobile-sheet {
  width: 100%;
  max-width: 600px;
  max-height: 75vh;
  background: rgba(20, 20, 35, 0.97);
  backdrop-filter: blur(30px);
  border-radius: 24px 24px 0 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: none;
  box-shadow: 0 -10px 60px rgba(0, 0, 0, 0.4);
  overflow-y: auto;
  padding: 8px 16px calc(90px + env(safe-area-inset-bottom, 0px));
}

.mobile-sheet::-webkit-scrollbar {
  width: 4px;
}

.mobile-sheet::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.15);
  border-radius: 4px;
}

.mobile-sheet-handle {
  width: 40px;
  height: 4px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  margin: 8px auto 16px;
}

/* 카테고리 */
.mobile-sheet-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-sheet-category {
  padding: 4px 0;
}

.mobile-sheet-category-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
}

.mobile-sheet-category-header > img {
  width: 22px;
  height: 22px;
  opacity: 0.9;
}

.mobile-sheet-category-header > span {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: -0.02em;
}

/* 메뉴 아이템 그리드 */
.mobile-sheet-items {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 4px 0;
  margin: 0;
  list-style: none;
}

.mobile-sheet-items > li {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 8px;
  border-radius: 16px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.mobile-sheet-items > li:active {
  transform: scale(0.95);
  background: rgba(255, 255, 255, 0.1);
}

.mobile-sheet-items > li > i {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
}

.mobile-sheet-items > li > span {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  word-break: keep-all;
  line-height: 1.3;
}

/* 바텀시트 트랜지션 */
.bottomsheet-enter-active {
  transition: opacity 0.25s ease;
}

.bottomsheet-enter-active .mobile-sheet {
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.bottomsheet-leave-active {
  transition: opacity 0.2s ease;
}

.bottomsheet-leave-active .mobile-sheet {
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.bottomsheet-enter-from {
  opacity: 0;
}

.bottomsheet-enter-from .mobile-sheet {
  transform: translateY(100%);
}

.bottomsheet-leave-to {
  opacity: 0;
}

.bottomsheet-leave-to .mobile-sheet {
  transform: translateY(100%);
}

@media (max-width: 480px) {
  .mobile-sheet-items {
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
  }

  .mobile-sheet-items > li {
    padding: 12px 6px;
  }

  .mobile-fab-group {
    bottom: calc(14px + env(safe-area-inset-bottom, 0px));
    left: 14px;
  }

  .mobile-fab {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
}

/* #### 모바일 플로팅 버튼 + 바텀시트 #### END */

/* #### 공통 #### START */
.root-container {}

.window-container {
  position: absolute;
  top:0%;
  left:0%;
  width:100%;
  height:100%;
  z-index:var(--z-index-middle);
  display:flex;
  align-items:center;
  justify-content:center;
}

.popup-fade-enter-active {
  transition: opacity 0.4s ease;
}
.popup-fade-leave-active {
  transition: opacity 0.3s ease;
}
.popup-fade-enter-from,
.popup-fade-leave-to {
  opacity: 0;
}

.popup-container {
  position: fixed;
  top:0%;
  left:0%;
  width:100%;
  height:100%;
  z-index:var(--z-index-middle);
  display:flex;
  align-items:center;
  justify-content:center;
}

.popup-container > #closer {
  position: absolute;
  top:0%;
  left:0%;
  width:100%;
  height:100%;
  z-index:9;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.main-container { 
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: var(--color-root-primary);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.main-container.hasIMG {
  background: none;
}
/* #### 공통 #### FINISH */


/* #### 반응형 #### START */
* {
  --max-width:1190px;
}

@media (max-width: 1280px) or (max-height: 800px) {
  * {
    --max-width:1024px;
  }
}

@media (max-width: 1024px) or (max-height: 768px) {
  * {
    --max-width:900px;
  }
}

@media (max-width: 1023px) or (max-height: 600px) {
  * {
    --max-width:700px;
  }
}

@media (max-width: 1200px) or (max-height: 800px) {
  .main-container > .header > li.center { display:none !important; }
  .main-container > .content > .right-menu { display:none !important; }
}

@media (max-width: 1024px) and (orientation: portrait) {
  * {
    --max-width: 100%;
  }

  /* 헤더 슬림화 */
  .main-container > .header {
    height: 56px;
    padding: 0 8px;
  }

  .main-container > .header > li {
    padding: 8px;
  }

  .main-container > .header .logo-box > .logo {
    width: 28px;
    height: 28px;
  }

  .main-container > .header .logo-box > .logo-text {
    font-size: 16px;
  }

  .main-container > .header .menu-list > a {
    width: 32px;
    height: 32px;
  }

  /* 뷰포트 높이 꽉 채우기 — 기기 비율에 맞게 자동 */
  .main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .special,
  .main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .normal {
    aspect-ratio: 10/16 !important;
    max-width: 100%;
    width: 100%;
    /* height: calc(100dvh - 56px - 40px); */
    /* aspect-ratio: 10 / 16; */
    padding: 8px 12px;
    box-sizing: border-box;
  }

  .main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .normal > .gapper {
    height: 100%;
  }

  /* 인디케이터 */
  .main-container > .content > .indicator {
    bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  }
}
/* #### 반응형 #### FINISH */



/*
  POPUP / WINDOW GSAP 까지 넣어서 재구현
*/


/* #### Header #### START */
.main-container > .header {
  position:fixed;
  left:0;
  top:0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  z-index:9;
}

.main-container > .header > li {
  width: 100%;
  height: 100%;
  display: flex; /* 수정 */
  align-items: center;
  flex: 1;
  padding: 16px;
  box-sizing: border-box;
}

.main-container > .header > li.left {
  justify-content: start;
}

.main-container > .header > li.center {
  flex: 2;
  justify-content: center;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: #fff;
}

.main-container > .header > li.right {
  justify-content: end;
}

.main-container > .header .logo-box {
  width:fit-content;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--font-size-base);
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}

.main-container > .header .logo-box:hover {
  transform: scale(1.1);
}

.main-container > .header .logo-box > .logo {
  width: auto;
  height: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
}

.main-container > .header .logo-box > .logo-text {
  font-size: 16px;
  font-weight: var(--font-weight-bold);
  color: #fff;
}

.team-avatar-area {
  position: relative;
  display: flex;
  align-items: center;
}

.team-avatar-stack {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 20px;
  transition: background 0.2s ease;
}

.team-avatar-stack:hover {
  background: rgba(255, 255, 255, 0.1);
}

.team-avatar-item {
  position: relative;
  width: 28px;
  height: 28px;
  margin-left: -10px;
  border-radius: 50%;
  flex-shrink: 0;
  animation: teamAvatarIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  transition: transform 0.15s ease, margin 0.15s ease;
}

.team-avatar-item:last-of-type {
  margin-left: 0;
}

.team-avatar-stack:hover .team-avatar-item {
  margin-left: -5px;
}

.team-avatar-stack:hover .team-avatar-item:last-of-type {
  margin-left: 0;
}

.team-avatar-item:hover {
  transform: scale(1.2) translateY(-2px);
  z-index: 99 !important;
}

.team-avatar-item > img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(30, 30, 50, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

@keyframes teamAvatarIn {
  from { opacity: 0; transform: scale(0.5) translateX(8px); }
  to   { opacity: 1; transform: scale(1) translateX(0); }
}

.team-avatar-more {
  width: 28px;
  height: 28px;
  margin-left: -10px;
  border-radius: 50%;
  background: rgba(99, 102, 241, 0.85);
  border: 2px solid rgba(30, 30, 50, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
  animation: teamAvatarIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) 0.25s both;
}

.team-popup {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 220px;
  max-height: 320px;
  background: rgba(15, 15, 25, 0.95);
  backdrop-filter: blur(24px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  z-index: 100;
}

.team-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.team-popup-header > span {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.team-popup-header > button {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 2px;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: color 0.15s;
}

.team-popup-header > button:hover {
  color: #fff;
}

.team-popup-actions {
  display: flex;
  gap: 6px;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.team-popup-actions > button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 0;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.team-popup-actions > button:hover {
  background: rgba(99, 102, 241, 0.2);
  border-color: rgba(99, 102, 241, 0.4);
  color: #fff;
}

.team-popup-actions > button > i {
  font-size: 14px;
}

.team-popup-list {
  list-style: none;
  margin: 0;
  padding: 6px;
  max-height: 260px;
  overflow-y: auto;
}

.team-popup-list > li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  transition: background 0.15s;
}

.team-popup-list > li:hover {
  background: rgba(255, 255, 255, 0.08);
}

.team-popup-list > li > img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.team-popup-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.team-popup-name {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-popup-enter-active,
.team-popup-leave-active {
  transition: all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.team-popup-enter-from,
.team-popup-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.95);
}

.main-container > .header .menu-list {
  width: fit-content;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--font-size-base);
}

.main-container > .header .menu-list > a {
  width: fit-content;
  height: 100%;
  aspect-ratio: 1/1;
  border-radius: 100%;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(24px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}

.main-container > .header .menu-list > a:hover {
  transform: scale(1.1);
}

.main-container > .header .menu-list > a > img {
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 100%;
}

/* #### Header #### FINISH */


/* #### Content #### START */
.main-container > .content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.main-container > .content > .right-menu {
  position: absolute;
  top: 0;
  z-index: var(--z-index-base);
  right: 16px;
  width: fit-content;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-container > .content >  .indicator {
  position: absolute;
  bottom: 16px;
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:var(--font-size-md);
  z-index: 9;
}

.main-container > .content > .indicator > span {
  width: var(--font-size-md);
  height: var(--font-size-md);
  border-radius: var(--font-size-lg);
  aspect-ratio: 1/1;
  background: rgba(255,255,255,0.4);
  color: var(--color-text-primary);
  backdrop-filter: blur(12px);
  display:flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  transform: scale(0.7);
}

.main-container > .content > .indicator > span:hover {
  transform: scale(1.1);
}

.main-container > .content > .indicator > span.feed {
  border:none;
  background: none;
  color: rgba(255,255,255,0.4);
  backdrop-filter: blur(0px);
  width: var(--font-size-lg) !important;
  height: var(--font-size-lg) !important;
  font-size: var(--font-size-lg);
}

.main-container > .content > .indicator > span#select {
  background: var(--color-brand);
  transform: scale(1.1);
}

.main-container > .content > .indicator > span#select.feed {
  font-size: var(--font-size-xl);
  background:none;
  color: var(--color-brand);
}

.main-container > .content > .swiper-container {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow:hidden;
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .special {
  aspect-ratio: 6 / 4 auto;
  width:100%;
  height:auto;
  max-width: var(--max-width);
  overflow: hidden;
}

/* after */
.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .normal {
  aspect-ratio: 6 / 4 auto;    /* ← 추가: .special과 동일한 비율 제한 */
  width:100%;
  height:auto;
  max-width: var(--max-width);
  display:flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;              /* ← 추가: 넘침 방지 */
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .normal > .gapper {
  width:100%;
  height: 100%;  /* 부모의 크기를 정확히 따라가도록 */
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  gap:24px;
  padding:0;
  margin:0;
  list-style: none;
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .normal > .gapper > .stack {
  flex:1 !important;
  width:100%;
  height:100%;
  overflow:visible;
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .normal > .gapper::-webkit-scrollbar {
  display: none;  /* 스크롤바 숨김 */
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide  > .grid-stack {
  aspect-ratio: 6 / 4;
  max-width: var(--max-width);
  width: 100%;
  height: auto;
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .item {
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color:#fff;
  font-size: var(--size-big);
  border-radius: var(--font-size-lg);
  cursor: pointer;
  gap:var(--font-size-md);
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .item > p {
  padding: 0%;
  margin: 0%;
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .item > i {
  font-size: var(--font-size-3xl);
}

.main-container > .content > .swiper-container > .swiper-wrapper > .swiper-slide > .item-twoXtwo {
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color:#fff;
  font-size: var(--size-big);
  border-radius: var(--font-size-lg);
  cursor: pointer;
  gap:var(--font-size-md);
  grid-column: 4 / 2;
  grid-row: 4 / 2;
}

.grid-stack > .grid-stack-item > .grid-stack-item-content {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  padding: var(--font-size-sm);
  box-sizing: border-box;
}
/* #### Content #### FINISH */

</style>

<style>
/* 기존 스타일 끝에 추가 */

/* driver.js 닫기 버튼 숨기기 */
.driver-popover-close-btn {
  display: none !important;
}

.driver-popover-title {
  font-size:24px !important;
  font-weight:600 !important;
}

.driver-popover-description {
  font-size:16px !important;
}

/* driver.js 버튼 크기 키우기 */
.driver-popover-footer button {
  padding: 6px 16px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
</style>